module.exports = __webpack_public_path__ + "static/media/FLOOR PP - 2020 NOVO PORTI.6caf5603.pdf";